import React from 'react'
import { BeatLoader,GridLoader } from 'react-spinners'

function Spinner({ size = 20, color = "#009EDF", margin = "0 auto", loading = true }) {
    return (
        <GridLoader className='flex items-center justify-center h-auto mt-8' loading={loading} color={color} size={size} margin={margin} />
    )
}

export default Spinner